// extracted by mini-css-extract-plugin
module.exports = {"center":"thanks_center__15xJ5","logo":"thanks_logo__nPOHK","content":"thanks_content__3MxjM","p":"thanks_p__3MFjH","btn":"thanks_btn__1AQYr"};